import React, { useEffect, useState } from "react";
import { Sparkles, X } from "lucide-react";
import { useRole } from "../context/RoleContext";

const BADGE_REVEAL_DELAY_MS = 1800;

const FloatingBadge = () => {
  const { badge } = useRole();
  const [visible, setVisible] = useState(false);
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    // appear after a small delay so it doesn't crash the entry
    const timer = setTimeout(() => setVisible(true), BADGE_REVEAL_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  if (closed) return null;

  return (
    <a
      href="#contact"
      className={`fixed bottom-5 left-5 z-40 hidden md:inline-flex items-center gap-2 px-3 py-2 rounded-full border border-[#FFF3E9]/25 bg-[#0B0B0D]/90 backdrop-blur shadow-lg float-y transition-all duration-500 ${
        visible
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-3 pointer-events-none"
      }`}
    >
      <Sparkles className="w-3.5 h-3.5 text-[#FFF3E9]" strokeWidth={1.5} />
      <span data-testid="floating-badge-text" className="text-[12px] text-[#EDEDED]">
        {badge}
      </span>
      <span className="mono text-[10px] text-[#8B7B6E]">·</span>
      <span className="mono text-[10px] tracking-wider text-[#FFF3E9]">
        AUG &lsquo;27
      </span>
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setClosed(true);
        }}
        className="ml-1 w-5 h-5 rounded-full text-[#8B7B6E] hover:text-[#EDEDED] hover:bg-white/5 flex items-center justify-center"
        aria-label="Dismiss"
      >
        <X className="w-3 h-3" />
      </button>
    </a>
  );
};

export default FloatingBadge;
